import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}`;

export const getUserInfo = (): Promise<any> =>
    axios.get(`${API_URL}/userinfo`).then(response => response.data);
